import moment from 'moment';
import * as uuid from 'uuid';
import { saveAs } from 'file-saver';
// Typescript transcription of - https://github.com/nwcell/ics.js
// Omitted rrules portion of implementation (configuration for recurring events)

const DATE_FORMAT = 'YYYYMMDDTHHmmss';
const SEPARATOR = navigator.appVersion.includes('Win') ? '\r\n' : '\n';

interface Event {
  id?: string;
  subject: string;
  description: string;
  location: string;
  begin: Date;
  stop: Date;
}

export default class ICS {
  private uidDomain = 'notable';
  private prodId = 'notable-intake-patient-app';

  private calendarEvents: string[] = [];
  private calendarStart: string;
  private calendarEnd: string;

  constructor(uidDomain?: string, prodId?: string) {
    if (
      navigator.userAgent.includes('MSIE') &&
      !navigator.userAgent.includes('MSIE 10')
    ) {
      throw new Error('Unsupported Browser');
    }
    if (uidDomain) this.uidDomain = uidDomain;
    if (prodId) this.prodId = prodId;
    this.calendarStart = [
      'BEGIN:VCALENDAR',
      'PRODID:' + this.prodId,
      'VERSION:2.0',
    ].join(SEPARATOR);
    this.calendarEnd = SEPARATOR + 'END:VCALENDAR';
  }

  calendar = () =>
    this.calendarStart +
    SEPARATOR +
    this.calendarEvents.join(SEPARATOR) +
    this.calendarEnd;

  open = () => {
    if (this.calendarEvents.length < 1) return false;
    const calendar = this.calendar();
    window.open(
      'data:text/calendar;charset=utf8,' + escape(calendar),
      '_blank',
    );
  };

  download = (filename = 'calendar', ext = '.ics') => {
    if (this.calendarEvents.length < 1) return false;
    const calendar = this.calendar();
    let blob;
    if (navigator.userAgent.indexOf('MSIE 10') === -1) {
      // chrome or firefox
      blob = new Blob([calendar]);
    } else {
      // ie
      // @ts-expect-error: no longer defined
      const bb = new MSBlobBuilder();
      bb.append(calendar);
      blob = bb.getBlob('text/x-vCalendar;charset=' + document.characterSet);
    }
    saveAs(blob, filename + ext);
    return calendar;
  };

  build = () => (this.calendarEvents.length < 1 ? false : this.calendar());

  addEvent = (event: Event) => {
    const calendarEvent = [
      'BEGIN:VEVENT',
      'UID:' + (event.id || uuid.v4()) + '@' + this.uidDomain,
      'CLASS:PUBLIC',
      'DESCRIPTION:' + event.description,
      'DTSTAMP;VALUE=DATE-TIME:' + moment().format(DATE_FORMAT),
      'DTSTART;VALUE=DATE-TIME:' + moment(event.begin).format(DATE_FORMAT),
      'DTEND;VALUE=DATE-TIME:' + moment(event.stop).format(DATE_FORMAT),
      'LOCATION:' + event.location,
      'SUMMARY;LANGUAGE=en-us:' + event.subject,
      'TRANSP:TRANSPARENT',
      'END:VEVENT',
    ].join(SEPARATOR);
    this.calendarEvents.push(calendarEvent);
  };
}
